// extracted by mini-css-extract-plugin
module.exports = {"root":"LegalPage_root__7_XpD","wrapper":"LegalPage_wrapper__bI8el"};